export const WEDNESDAY_COUPONS = 'Wednesday Coupons'
export const AVAILABLE_COUPONS = 'Available Coupons'
export const APPLY_TEXT = 'APPLY'
export const OKAY_TEXT = 'OKAY'